module.exports = __webpack_public_path__ + "img/06.a3782d2e.jpg";